import type {RootStore} from 'stores/rootStore';
import type {HumanizerMode} from 'config';

/** The landing's explicit Humanize click uses the ordinary run/login continuation. */
export const acceptHumanizerHandoff = async (root: RootStore, text: string, mode: HumanizerMode | null, autorun: boolean) => {
    root.user.forceHumanizer(true);
    root.layout.setWorkspace('humanizer');
    if (mode) root.humanizer.setMode(mode);
    root.humanizer.setInputText(text);
    if (autorun) {
        await root.user.refresh();
        root.humanizer.runFromButton();
    }
};
